export const PropertyEditIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.75 8.625C15.75 5.26624 15.75 3.58687 14.7066 2.54343C13.6631 1.5 11.9837 1.5 8.625 1.5C5.26624 1.5 3.58687 1.5 2.54343 2.54343C1.5 3.58687 1.5 5.26624 1.5 8.625C1.5 11.9837 1.5 13.6631 2.54343 14.7066C3.54729 15.7104 5.13976 15.7485 8.25 15.7499"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
    />
    <path
      d="M1.5 5.25H15.75"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 12H8.625M4.5 12H5.25M7.5 9H12M4.5 9H5.25"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.9475 11.1538C15.2717 10.3988 14.8661 10.4438 14.4156 10.5786C14.1002 10.6235 13.0189 11.8817 12.5684 12.2824C11.8286 13.0109 11.0855 13.7609 11.0365 13.8588C10.8964 14.0858 10.7661 14.4879 10.703 14.9372C10.5859 15.6113 10.3531 16.3361 10.631 16.435C10.7661 16.6148 11.4419 16.3751 12.1178 16.2763C12.5684 16.1954 12.8837 16.1055 13.109 15.9707C13.4244 15.782 14.0101 15.1169 15.0194 14.1284C15.6523 13.4641 16.2629 13.005 16.4431 12.5557C16.6233 11.8817 16.353 11.5222 15.9475 11.1538Z"
      stroke="currentColor"
      strokeWidth="1.125"
    />
  </svg>
);
